module.exports = __webpack_public_path__ + "static/img/grubby-logo.dfff57e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/grubby-logo.png
// module id = LB7s
// module chunks = 1